import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    box-shadow:
        0 3px 5px rgba(0, 0, 0, 0.06),
        0 1px 4px rgba(0, 0, 0, 0.03);
    padding: 15px;
    background-color: rgba(255, 255, 255, 0.9);
`;
export const Header = styled.div`
    font-family: ${({ theme }) => theme.font.title};
    color: ${({ theme }) => theme.text};
    font-weight: normal;
    text-align: center;
    font-size: 13px;
`;
const Body = styled.div`
    font-family: ${({ theme }) => theme.font.regular};
    color: ${({ theme }) => theme.text};
    font-weight: normal;
    font-size: 11px;
    text-align: left;
`;
export const Section = styled.div`
    margin-top: 15px;
`;

export const BusinessChangeTooltip = ({
    active = false,
    payload = null,
    labelFormatter = (label) => label,
    label = '',
    formatter,
}) => {
    if (!(active && payload && payload[0])) return null;

    return (
        <Container>
            <Header>{labelFormatter(label)}</Header>

            <Body>
                {payload.map((row, index) => (
                    <Section key={row.name}>{formatter(row.value, row.name, row, index)}</Section>
                ))}
            </Body>
        </Container>
    );
};

export default BusinessChangeTooltip;
